BaseModel = require './base_model.coffee'

class global.ContactCustomField extends BaseModel
  @ATTRIBUTES = {
    id: {}
    custom_field_id: {}
    value: {}
    field: {}
    kind: {}
    options: {}
  }



// WEBPACK FOOTER //
// ./src/models/contact_custom_field.coffee